<template>
  <v-layout class="restaurant-members-container">
    <v-container fluid>
      <v-card>
        <v-card-title>
          <span>{{ $t('users') }}</span>
          <v-spacer></v-spacer>
          <v-btn color="green" class="white--text" @click="createNewMember">{{
            $t('users.new')
          }}</v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ $t('users.subtitle') }}
        </v-card-subtitle>
        <v-card-text>
          <template v-if="!members">
            <v-skeleton-loader type="list-item" />
          </template>
          <template v-else>
            <template v-if="!members.length">
              {{ $t('users.empty') }}
            </template>
            <template v-else>
              <v-list-item
                class="member-item"
                v-for="member in members"
                :key="member.id"
              >
                <v-list-item-avatar>
                  <v-icon class="handle">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <span class="name children-inline">
                    <span class="mr-1">{{ member.user.name }}</span>
                    <v-chip
                      small
                      v-if="chipData[member.type]"
                      text-color="#fff"
                      :color="chipData[member.type].color"
                      >{{ chipData[member.type].title }}</v-chip
                    >
                  </span>
                  <span
                    class="description grey--text"
                    v-if="member.description"
                  >
                    {{ member.description }}
                  </span>
                </v-list-item-content>
                <v-list-item-action class="flex-row align-center">
                  <v-btn
                    icon
                    @click="edit(member)"
                    :disabled="member.type === 'owner'"
                    ><v-icon>edit</v-icon></v-btn
                  >
                </v-list-item-action>
              </v-list-item>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IUser } from '../../interfaces/IUser';
  import { IMember, MemberRole } from '../../interfaces/IMember';
  import RestaurantsService from '../../api/services/restaurants.service';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { IBranch } from '../../interfaces/IBranch';
  import NewItemModal from '../modals/NewItemModal.vue';
  import NewMemberModal from '../modals/NewMemberModal.vue';

  @Component
  export default class RestaurantMembers extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() branches: IBranch[];
    restaurantsService = new RestaurantsService();
    members: IMember[] = null;
    chipData = {
      [MemberRole.Owner]: {
        title: 'Dueño',
        color: '#d09d53',
      },
      [MemberRole.Admin]: {
        title: 'Administrador',
        color: 'orange',
      },
    };

    async created() {
      await this.loadMembers();
    }

    async loadMembers() {
      this.members = await RestaurantsService.getMembers(this.restaurant.id);
    }

    createNewMember() {
      this.$modal.show(
        NewMemberModal,
        {
          restaurant: this.restaurant,
          branches: this.branches,
        },
        {
          name: 'member',
          adaptive: true,
          height: 'auto',
          width: 1200,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadMembers();
          },
        }
      );
    }

    edit(member: IMember) {
      this.$modal.show(
        NewMemberModal,
        {
          restaurant: this.restaurant,
          branches: this.branches,
          member,
        },
        {
          name: 'member',
          adaptive: true,
          height: 'auto',
          width: 1200,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadMembers();
          },
          deleted: () => {
            this.members.splice(this.members.indexOf(member), 1);
            this.$modal.hide('member');
          },
        }
      );
    }
  }
</script>
